import { render, staticRenderFns } from "./ContryDetails.vue?vue&type=template&id=78271356&scoped=true&"
import script from "./ContryDetails.vue?vue&type=script&lang=js&"
export * from "./ContryDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContryDetails.vue?vue&type=style&index=0&id=78271356&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78271356",
  null
  
)

export default component.exports